import { AppKeycloakGuard } from './app.keycloakguard';
import { CanActivateFn } from '@angular/router';
import { AppAuthGuard } from '@app/guard/app.authguard';
import { Injectable } from '@angular/core';
import { AuthguardOption } from '../enum/authguardOption';

@Injectable()
export class GuardFactory {
  constructor(
    private authGuard: AppAuthGuard,
    private appKeycloakGuard: AppKeycloakGuard
  ) {}

  getInstance(key: string): {
    canActivate: CanActivateFn;
  } {
    switch (key) {
      case AuthguardOption.KEYCLOAK_OFF:
        return this.authGuard;
      case AuthguardOption.KEYCLOAK_ON:
        return this.appKeycloakGuard;
    }
  }
}
